import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route, hashHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import 'styles/style.scss'

import App from 'containers/App/App.jsx'
import StrongholdExternal from 'containers/StrongholdExternal/StrongholdExternal.jsx'
import Stub from 'containers/Stub/Stub.jsx'

import store from 'state/store'
import { hideTooltip } from 'helpers/web_to_client'

const history = syncHistoryWithStore(hashHistory, store)

const render = () => ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route component={App} >
                <Route path='/:locale/:clanId' component={StrongholdExternal} />
                <Route path='stub' component={Stub} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('content')
)

// IE10 Intl polyfill - conditionally load locale polyfill files
if (!window.Intl) {
    require.ensure([], function(require) {
        require('intl')
        require('intl/locale-data/jsonp/be.js')
        require('intl/locale-data/jsonp/bg.js')
        require('intl/locale-data/jsonp/cs.js')
        require('intl/locale-data/jsonp/da.js')
        require('intl/locale-data/jsonp/de.js')
        require('intl/locale-data/jsonp/el.js')
        require('intl/locale-data/jsonp/en.js')
        require('intl/locale-data/jsonp/es.js')
        require('intl/locale-data/jsonp/et.js')
        require('intl/locale-data/jsonp/fi.js')
        require('intl/locale-data/jsonp/fil.js')
        require('intl/locale-data/jsonp/fr.js')
        require('intl/locale-data/jsonp/hr.js')
        require('intl/locale-data/jsonp/hu.js')
        require('intl/locale-data/jsonp/id.js')
        require('intl/locale-data/jsonp/it.js')
        require('intl/locale-data/jsonp/ja.js')
        require('intl/locale-data/jsonp/kk.js')
        require('intl/locale-data/jsonp/ko.js')
        require('intl/locale-data/jsonp/lt.js')
        require('intl/locale-data/jsonp/lv.js')
        require('intl/locale-data/jsonp/ms.js')
        require('intl/locale-data/jsonp/nl.js')
        require('intl/locale-data/jsonp/nn-NO.js')
        require('intl/locale-data/jsonp/pl.js')
        require('intl/locale-data/jsonp/pt.js')
        require('intl/locale-data/jsonp/ro.js')
        require('intl/locale-data/jsonp/ru.js')
        require('intl/locale-data/jsonp/sr.js')
        require('intl/locale-data/jsonp/sv.js')
        require('intl/locale-data/jsonp/th.js')
        require('intl/locale-data/jsonp/tr.js')
        require('intl/locale-data/jsonp/uk.js')
        require('intl/locale-data/jsonp/vi.js')
        require('intl/locale-data/jsonp/zh.js')
        render()
    }, 'intl-polyfill')
} else {
    render()
}
window.onbeforeunload = () => {
    // we wanna be ensure that all ingame tooltips became closed when we close interface @see WGCQ-573
    hideTooltip()
}



// WEBPACK FOOTER //
// ./entry_points/index.external.js